import { httpClient } from 'src/libs';

// Base URL for feedbacks via comms-api proxy
const API_URL = `${process.env.REACT_APP_BASE_URL}/comms-api/v1/feedbacks`;

export interface FeedbackCreate {
  feedbackable_id: string;
  feedbackable_type: 'Message';
  score: number; // 1 or -1
  reason?: string;
  comment?: string;
  voter_uuid?: string;
}

export interface FeedbackUpdate {
  score?: number; // 1 or -1
  reason?: string;
  comment?: string;
  voter_uuid?: string;
}

const createFeedback = (data: FeedbackCreate) => {
  return httpClient.post(API_URL, data);
};

const updateFeedback = (feedbackId: string, data: FeedbackUpdate) => {
  return httpClient.patch(`${API_URL}/${feedbackId}`, data);
};

const getFeedback = (feedbackId: string) => {
  return httpClient.get(`${API_URL}/${feedbackId}`);
};

const deleteFeedback = (feedbackId: string) => {
  return httpClient.delete(`${API_URL}/${feedbackId}`);
};

export default {
  createFeedback,
  updateFeedback,
  getFeedback,
  deleteFeedback,
}; 
